import { AgResourceLanguage } from '../types';
import { login as EnUsLogin } from '../en-us/login';

export const login: AgResourceLanguage['login'] = {
  ...EnUsLogin,
  header: 'Onjuist e-mailadres of wachtwoord',
  description:
    'Zorg ervoor dat dit hetzelfde e-mailadres is dat je hebt gebruikt bij het plaatsen van je bestelling of het aanmaken van je account.'
};
